import { writable } from 'svelte/store';
import type { User } from 'customTypes/user';

const userStore = writable<User>({
	isLoggedIn: false,
	_id: '',
	email: '',
	password: '',
	newsletter: {
		subscribed: false,
		assets: [],
		currency: '',
		time: '',
		timezone: '',
		lastEmailSent: 0,
	},
	watchlist: {},
});

export default userStore;
